import { Capacitor, registerPlugin } from '@capacitor/core';

const settings = registerPlugin('WiwDeviceSettings');
export const canOpenMediaSettings = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';

export async function openMediaSettings() {
  try { await settings.openMediaSettings(); }
  catch (error) {
    // Existing shells already expose the same fixed app-settings destination.
    if (error?.code !== 'UNIMPLEMENTED') throw error;
    await settings.openLocation();
  }
}

const permissionError = (resource, status) => Object.assign(new Error('MEDIA_PERMISSION_DENIED'), {
  name: 'NotAllowedError', resource, permission: status,
});

// Return synchronously on the web: getUserMedia must retain the original tap.
// Native checks are deliberately fresh, including after returning from Settings.
export function prepareMediaPermissions({ kind, silent, isCurrent }) {
  if (!canOpenMediaSettings()) return null;
  return (async () => {
    try {
      let permissions = await settings.checkMediaPermissions();
      for (const resource of [...(kind === 'video' ? ['camera'] : []), ...(!silent ? ['microphone'] : [])]) {
        if (!isCurrent()) return false;
        if (permissions?.[resource] === 'prompt') {
          // One prompt at a time. Closing the recorder while camera consent is
          // pending must not later trigger an unrelated microphone prompt.
          permissions = await settings.requestMediaPermissions({ [resource]: true });
        }
        if (!isCurrent()) return false;
        if (permissions?.[resource] !== 'granted') {
          const status = permissions?.[resource];
          if (status === 'denied' || status === 'restricted') throw permissionError(resource, status);
          throw new Error('MEDIA_PERMISSION_UNAVAILABLE');
        }
      }
      return true;
    } catch (error) {
      // Older native shells still rely on WebKit/OS authorization. Never treat
      // a denial or an actual bridge failure as permission to proceed.
      if (error?.code === 'UNIMPLEMENTED') return isCurrent();
      throw error;
    }
  })();
}
